import { useTranslation } from 'react-i18next';

interface LanguageToggleProps {
  className?: string;
}

export default function LanguageToggle({ className = '' }: LanguageToggleProps) {
  const { i18n } = useTranslation();
  const isFrench = i18n.language === 'fr';

  const handleToggle = () => {
    i18n.changeLanguage(isFrench ? 'en' : 'fr');
  };

  return (
    <button
      onClick={handleToggle}
      className={`flex items-center gap-1.5 px-4 py-1.5 rounded-full border-2 border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#0A1F44] transition-all text-sm font-bold whitespace-nowrap cursor-pointer ${className}`}
      aria-label="Toggle language"
      title={isFrench ? 'Switch to English' : 'Passer en Français'}
    >
      <div className="w-4 h-4 flex items-center justify-center">
        <i className="ri-translate-2 text-base leading-none"></i>
      </div>
      <span>{isFrench ? 'EN' : 'FR'}</span>
    </button>
  );
}
